import { Pressable, Text } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const PressableTime = Pressable.withConfig<{ $isSelected: boolean }>(p => ({
  minWidth: '$32',
  marginX: '$2',
  background: p.$isSelected
    ? primitive.$bbqBrown
    : getDesignToken('pickup-timed-fire-selector-button-background'),
  borderRadius: primitive.$borderRadius,
  paddingY: '$3',
  paddingX: '$4',
  _pressed: {
    background: primitive.$shadowColor,
  },
  _disabled: {
    background: primitive.$greyTwo,
  },
  _web: {
    cursor: 'pointer',
  },
}));

export const TimeText = Text.withConfig<{ $isSelected: boolean }>(p => ({
  textAlign: 'center',
  color: p.$isSelected ? primitive.$mayoEggWhite : primitive.$bbqBrown,
}));
